import type { CandidateRecord, LookupOption, Lookups } from '@/lib/api/schemas';

import type { Destination } from '../steps';

export interface StepProps {
  record: CandidateRecord;
  lookups: Lookups;
  /** Called with where to go next; the page turns it into navigation. */
  onNext: (to: Destination) => void;
}

export const CHOICE_ERROR = 'Please select a valid answer';

export const yesNo = (b: boolean | null | undefined): 'Yes' | 'No' | undefined =>
  b === true ? 'Yes' : b === false ? 'No' : undefined;

export const toBool = (s: string | undefined): boolean | null =>
  s === 'Yes' ? true : s === 'No' ? false : null;

/** RHF gives `false` for a checkbox group with nothing ticked. */
export const asList = (v: string[] | false | undefined): string[] => (Array.isArray(v) ? v : []);

export const YES_NO: readonly LookupOption[] = [
  { value: 'Yes', label: 'Yes' },
  { value: 'No', label: 'No' },
];

export const YES_NO_MAYBE: readonly LookupOption[] = [
  ...YES_NO,
  { value: 'Maybe', label: 'Maybe' },
];
